var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$mq=='lg')?_c('footer',[_c('p',[_vm._v(_vm._s(_vm._f("trans")('layouts/footer.paragraphs.0')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("trans")('layouts/footer.paragraphs.1')))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }